import { Pipe, PipeTransform } from "@angular/core";
import { Guid } from "guid-typescript";
import { JobModel } from "src/app/models/job.model";

@Pipe({
    name: 'filterByTaskGroup',
    pure: false
})
export class FilterByTaskGroupPipe implements PipeTransform {
    transform(jobs: JobModel[], taskGroupId: Guid): any {
        
        if (!jobs || !taskGroupId) {
            return jobs;
        }

        return jobs.filter(j => {
            return j.groupId == taskGroupId;
        });

        
    }
}